import { Dispatch, SetStateAction, useCallback } from 'react'
import {
  filterBreadsByCategory,
  filterBreadsByCurrentTab,
  filterBreadsByKeyword,
  filterBreadsByStatus,
  filterBreadsByType,
} from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType, StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { DayOfWeekType } from 'lib/daysOfWeek'

type UseSelectCategoryParams = {
  breads: BreadType[]
  categories: CategoryType[]
  keyword: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  setCategoryName: Dispatch<SetStateAction<string>>
  isShownPrivate: boolean
  breadTypes?: StockUnionType[]
  stocks?: StockType[]
  schedules?: ScheduleType[]
  isFuture?: boolean
  checkedOrderTypes?: string[]
  dayOfWeek?: DayOfWeekType
  isTemporaryClose?: boolean
  currentTab?: 'released' | 'unreleased'
}

const useSelectCategory = (params: UseSelectCategoryParams) => {
  const {
    breads,
    categories,
    keyword,
    setBreadList,
    setCategoryName,
    isShownPrivate,
    breadTypes,
    stocks,
    schedules,
    isFuture,
    checkedOrderTypes,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  } = params
  return useCallback(
    (value: string) => {
      let _breads = [...breads]
      if (value === '' && keyword === '') {
        // カテゴリーが未選択かつキーワードも未選択であれば初期値に戻す
        _breads = filterBreadsByStatus(_breads, isShownPrivate)
      } else if (value === '' && keyword !== '') {
        // カテゴリーが未選択でキーワードのフィルタリング
        _breads = filterBreadsByStatus(_breads, isShownPrivate)
        _breads = filterBreadsByKeyword(keyword, _breads)
      } else {
        // カテゴリでフィルターした後にキーワードでフィルタリング
        _breads = filterBreadsByStatus(_breads, isShownPrivate)
        _breads = filterBreadsByCategory(value, categories, _breads)
        _breads = filterBreadsByKeyword(keyword, _breads)
      }
      if (breadTypes) {
        _breads = filterBreadsByType(_breads, breadTypes)
      }
      if (stocks && schedules && dayOfWeek && currentTab && checkedOrderTypes) {
        _breads = filterBreadsByCurrentTab({
          breads: _breads,
          checkedOrderTypes,
          currentTab,
          dayOfWeek,
          stocks,
          schedules,
        })
      }
      setBreadList([..._breads])
      setCategoryName(value)
    },
    [
      breads,
      categories,
      keyword,
      setBreadList,
      setCategoryName,
      isShownPrivate,
      breadTypes,
      stocks,
      schedules,
      isFuture,
      checkedOrderTypes,
      dayOfWeek,
      isTemporaryClose,
      currentTab,
    ]
  )
}

export default useSelectCategory
